<template>
    <div id="companyorderDetail">
        <div class="mybreadcrumb">
            <div style="display:flex;align-items:center">
                <i class="iconfont icon-biaodan" style="margin-right:10px;color:#999"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right" >
                    <el-breadcrumb-item>订单和计费</el-breadcrumb-item>
                    <el-breadcrumb-item>我的订单</el-breadcrumb-item>
                    <el-breadcrumb-item>订单详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <button class="return-button" @click="btnback">返回</button>
        </div>
        <div class="detailinfo-wraper">
            <div class="payStatus-wraper"  v-show="pngStatus=='NOTPAY'">
                <div class="status-display" >
                    <img :src="waitpng"  style="imgstyle"/>
                    <span class="paystatus">待支付</span>
                </div>
            </div>

            <div class="payStatus-wraper"  v-show="pngStatus=='ACCEPT'">
                <div class="status-display" >
                    <img :src="waitpng"  style="imgstyle"/>
                    <span class="paystatus">已接收，待扣款</span>
                </div>
            </div>
            
            <div class="payStatus-wraper"  v-show="pngStatus=='PROCESSING'">
                <div class="status-display" style="position:relative;top:-5px">
                    <img :src="waitpng"  style="imgstyle"/>
                    <span class="paystatus">处理中</span>
                </div>
                <div style="font-family: MicrosoftYaHei;font-size: 12px;color: #666666;position:relative;left:-110px;top:28px">网银支付成功后，需1-2个工作日进行处理并更新订单状态</div>
            </div>

            <div class="payStatus-wraper"  v-show="pngStatus=='SUCCESS'">
                <div class="status-display" >
                    <img :src="succeedpng"  style="imgstyle"/>
                    <span class="paystatus">支付成功</span>
                </div>
            </div>
            <div class="payStatus-wraper"  v-show="pngStatus=='CLOSED'">
                <div class="status-display" >
                    <img :src="canclepng"  style="imgstyle"/>
                    <span class="paystatus">已关闭</span>
                </div>
            </div>
            <div class="payStatus-wraper"  v-show="pngStatus=='PAYERROR'">
                <div class="status-display" >
                    <img :src="failedpng"  style="imgstyle"/>
                    <span class="paystatus">支付失败</span>
                </div>
            </div>
            <div class="payStatus-wraper"  v-show="pngStatus=='COMPLETED'">
                <div class="status-display" >
                    <img :src="canclepng"  style="imgstyle"/>
                    <span class="paystatus">已完成</span>
                </div>
            </div>
            <div class="common-leftblue" style="margin-top:50px">
                基本信息
            </div>
            <el-table
                :data="baseInfoTableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'10px 0',background:'#F1F3F2'}"
                style="width: 100%;margin-top:20px"
                :cell-class-name="tabCellClassName"
             >
                <el-table-column
                    label="订单编号"
                    align="center"
                    prop="orderNo"
                    show-overflow-tooltip
                    >
                </el-table-column>
                <el-table-column
                    label="下单时间"
                    align="center"
                    prop="createdAt"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    label="订单状态"
                    align="center"
                    >
                    <template slot-scope="scope">
                            <div v-if="scope.row.tradeStatus==='PAYERROR'" class="table-status bgcred">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='SUCCESS'" class="table-status bgcgreen">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='NOTPAY'" class="table-status bgcorange">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='CLOSED'" class="table-status bgcgrey">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else-if="scope.row.tradeStatus==='COMPLETED'" class="table-status bgcgrey">
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                            <div v-else>
                                <span>{{scope.row.tradeStatus | tradeStatusModify}}</span>
                            </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="支付方式"
                    align="center"
                    prop="payTypeDescription">
                </el-table-column>
                <el-table-column
                    label="原价(元)"
                    align="center"
                    prop="orderAmount">
                </el-table-column>
                <el-table-column
                    label="应付金额(元)"
                    align="center"
                    prop="payAmount">
                </el-table-column>
                <el-table-column
                    label="实付金额(元)"
                    align="center"
                    prop="actualAmount">
                </el-table-column>
             </el-table>
             <div class="common-leftblue" style="margin-top:40px">
                商品信息
            </div>
            <el-table
                :data="goodsInfoTableData"
                border
                :header-cell-style="{color:'#333333',fontFamily:'MicrosoftYaHei',fontSize:'12px',fontWeight:400,padding:'10px 0',background:'#F1F3F2'}"
                style="width: 100%;margin-top:20px"
                :cell-class-name="tabCellClassName"
             >
                <el-table-column
                    label="产品名称"
                    align="center"
                    prop="productName"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    label="销售包"
                    align="center"
                    prop="sellingPackageName"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    label="会员时长"
                    align="center"
                    prop="membershipDuration">
                </el-table-column>
                <el-table-column
                    label="购买数量"
                    align="center"
                    prop="purchaseQuantity">
                </el-table-column>
             </el-table>

            <div class="common-leftblue" style="margin-top:40px" v-if="istotalshow">
                发票信息
            </div>
            <div v-if="isNeedInvoice">
                <el-form ref="form" 
                    :model="companyInvoiceForm" 
                    label-width="230px"
                    style="text-align:left;margin-top:30px"
                    class="companyInvo-wraper"
                    v-if="istotalshow">
                    <div style="">                 
                        <el-form-item label="抬头类型 :" >
                            <span class="commonFZ14CO33">{{companyInvoiceForm.tittleType}}</span>
                        </el-form-item>
                        <el-form-item label="发票抬头 :" >
                            <span class="commonFZ14CO33">{{companyInvoiceForm.invoiceHeader}}</span>
                        </el-form-item>
                        <el-form-item label="发票类型 :" >
                            <span class="commonFZ14CO33">{{companyInvoiceForm.invoiceType}}</span>
                        </el-form-item>
                        <el-form-item label="统一社会信用代码 :" v-if="!ispersonalshow">
                            <span class="commonFZ14CO33">{{companyInvoiceForm.unifiedSocialCreditCode}}</span>
                        </el-form-item>
                        <el-form-item label="开户银行名称 :" v-if="!ispersonalshow">
                            <span class="commonFZ14CO33">{{companyInvoiceForm.bankName}}</span>
                        </el-form-item>
                        <el-form-item label="基本开户账号 :" v-if="!ispersonalshow" >
                            <span class="commonFZ14CO33">{{companyInvoiceForm.bankAccount}}</span>
                        </el-form-item>
                        <el-form-item label="注册场所地址 :"  v-if="!ispersonalshow">
                            <span class="commonFZ14CO33">{{companyInvoiceForm.registeredAddress}}</span>
                        </el-form-item>
                        <el-form-item label="注册固定电话 :" v-if="!ispersonalshow">
                            <span class="commonFZ14CO33">{{companyInvoiceForm.registeredTel}}</span>
                        </el-form-item>
                        <el-form-item label="开票内容 :" >
                            <span class="commonFZ14CO33">{{companyInvoiceForm.invoiceContent}}</span>
                        </el-form-item>
                        <el-form-item label="备注 :">
                            <span class="commonFZ14CO33">{{companyInvoiceForm.invoiceRemark}}</span>
                        </el-form-item>
                    </div>
                </el-form>

                <div class="common-leftblue" style="margin-top:40px" v-if="istotalshow"> 
                    发票邮寄地址
                </div>

                <el-form ref="form" 
                    :model="invoiceMailForm" 
                    label-width="230px"
                    style="text-align:left;margin-top:30px;padding-bottom:10px"
                    class="companyInvo-wraper"
                    v-if="istotalshow">
                    <div style="">                 
                        <el-form-item label="联系人 :" >
                            <span class="commonFZ14CO33">{{invoiceMailForm.contactName}}</span>
                        </el-form-item>
                        <el-form-item label="联系电话 :" >
                            <span class="commonFZ14CO33">{{invoiceMailForm.contactPhone}}</span>
                        </el-form-item>
                        <el-form-item label="邮寄地址 :" >
                            <span class="commonFZ14CO33">{{invoiceMailForm.contactAddress}}</span>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div v-else style="font-size:14px;margin-top:20px;text-align:left;margin-left:10px">
                不需要发票
            </div>
        </div>
    </div>
</template>

<script>
import Moment from 'moment';
import CommonBreadcrumb from '@/components/CommonBreadcrumb'
import {GetOrderDetailsApi} from '@/js/saleOnLineApi.js'
import {GetEnterpriseOrderDetailsApi} from '@/js/enterPriseApi.js'
export default {
    name:'comorderDetail',
    data() {
        return {
            succeedpng:require('@/assets/img/wxzfbpay/succeed.png'),
            waitpng:require('@/assets/img/wxzfbpay/wait.png'),
            failedpng:require('@/assets/img/wxzfbpay/failed.png'),
            canclepng:require('@/assets/img/wxzfbpay/cancle.png'),
            pngStatus:'',
            baseInfoTableData:[],
            goodsInfoTableData:[],
            companyInvoiceForm:{

            },
            invoiceMailForm:{
                contactName:'',
                contactPhone:'',
                contactAddress:''
            },
            orderNo:'',
            istotalshow:false,
            ispersonalshow:false,
            isNeedInvoice:true

        }
    },
    components:{
        CommonBreadcrumb
    },
    filters:{
        tradeStatusModify(val){
            if(val==='SUCCESS'){
                return '支付成功'
            }else if(val==='NOTPAY'){
                return '待支付'
            }else if(val==='CLOSED'){
                return '已关闭'
            }else if(val==='PAYERROR'){
                return '支付失败'
            }else if(val==='COMPLETED'){
                return '已完成'
            }else if(val=='PROCESSING'){
                return '处理中'
            }else if(val=='ACCEPT'){
                return '已接收,待扣款'
            }else{
                return val
            }
        }
    },
    created() {
        if(this.$route.query.orderNo){
            this.orderNo=this.$route.query.orderNo
            this.orderDetail()
        }
        
    },
    methods: {
        tabCellClassName({row, column, rowIndex, columnIndex}){//表格样式
            return 'cellstyle'
        },
        confirmMessage(){
            let that=this; 
               this.$confirm('您确定要取消该订单吗?', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    that.cancleBtnClick();
                }).catch(() => {  
            });
        },
        btnback(){
            this.$router.push('/companyOrder')
        },
        orderDetail(){//订单详情
            GetEnterpriseOrderDetailsApi(this.orderNo)
            .then(res=>{
                if(res.status===200 && res.data.error_code===0){
                    console.log(res)
                    const {data}=res.data;
                    let baseobj={
                        orderNo:data.orderNo,
                        createdAt:data.createdAt?Moment(data.createdAt).format('YYYY-MM-DD HH:mm:ss'):'',
                        tradeStatus:data.orderStatus.name,
                        orderAmount:data.orderAmount,
                        payAmount:data.payAmount,
                        actualAmount:data.actualAmount,
                        payTypeDescription:data.orderStatus.name=='SUCCESS'||data.orderStatus.name=='COMPLETED'?data.payTypeDescription:''
                    }
                    this.baseInfoTableData.push(baseobj)
                    this.pngStatus=data.orderStatus.name;
                    let goodsobj={
                        membershipDuration:data.subItems[0].membershipDuration,
                        //productName:data.subItems[0].productName,
                        productName:data.onLineProductName,
                        sellingPackageName:data.subItems[0].sellingPackageName,
                        purchaseQuantity:data.subItems[0].purchaseQuantity
                    }
                    this.goodsInfoTableData.push(goodsobj)
                    
                    if(data.sendInvoiceAddress){
                        this.istotalshow=true;
                        this.invoiceMailForm.contactName=data.sendInvoiceAddress.addressee;
                        this.invoiceMailForm.contactPhone=data.sendInvoiceAddress.phone;
                        this.invoiceMailForm.contactAddress=data.sendInvoiceAddress.province+'/'+data.sendInvoiceAddress.city+'/'+data.sendInvoiceAddress.areaOrCounty+" "+data.sendInvoiceAddress.detailedAddress
                        
                        if(data.invoiceInfo.bankAccount){
                          
                            this.companyInvoiceForm.unifiedSocialCreditCode=data.invoiceInfo.unifiedSocialCreditCode
                            this.companyInvoiceForm.registeredTel=data.invoiceInfo.registeredTel
                            this.companyInvoiceForm.registeredAddress=data.invoiceInfo.registeredAddress
                            this.companyInvoiceForm.bankAccount=data.invoiceInfo.bankAccount
                            this.companyInvoiceForm.bankName=data.invoiceInfo.bankName
                            this.companyInvoiceForm.invoiceType=data.invoiceInfo.invoiceType.description
                            this.companyInvoiceForm.invoiceHeader=data.invoiceInfo.invoiceHeader
                            this.companyInvoiceForm.tittleType='企业'
                            this.companyInvoiceForm.invoiceRemark=data.invoiceInfo.invoiceRemark
                            this.companyInvoiceForm.invoiceContent=data.invoiceInfo.invoiceContent
                            this.ispersonalshow=false
                        }else{
                           
                            this.companyInvoiceForm.invoiceType='增值税普通发票'
                            this.companyInvoiceForm.invoiceHeader='个人'
                            this.companyInvoiceForm.tittleType='个人'
                            this.companyInvoiceForm.invoiceRemark=data.invoiceInfo.invoiceRemark
                            this.companyInvoiceForm.invoiceContent=data.invoiceInfo.invoiceContent
                            this.ispersonalshow=true
                        }
                        

                    }else{
                        this.istotalshow=false;
                    }
                    if(data.invoiceInfo.invoiceContent){
                        this.isNeedInvoice=true
                    }else{
                        this.isNeedInvoice=false
                    }


                }else{
                    this.$message.error(res.data.error_msg)
                }
            })
            .catch(err=>{
                if(err.data && err.data.errorMessages){
                    this.$message.error(err.data.errorMessages[0]);
                }else if(err.data){
                    this.$message.error(err.data);
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
    #companyorderDetail{
        background:#fff !important;
        min-height: 100%;
        /deep/ .el-breadcrumb{
            .el-breadcrumb__inner{
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #666666;
                font-weight: 400;
            }
            .el-breadcrumb__separator{
                font-size: 12px !important;
                color: #666666;
            }
        }
        .mybreadcrumb{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 10px 20px;
            border-bottom: 1px solid #EAEAEA;
            .return-button{
                font-size: 12px;
                color: #666;
                font-family: MicrosoftYaHei;
                margin-right: 20px;
                width: 60px;
                height: 30px;
                background: #F6F6F6;
                border: 1px solid #E0E0E0;
                border-radius: 2px;
                line-height: 30px;
                cursor: pointer;
            }
        }
        .detailinfo-wraper{
            padding: 30px 30px 50px 30px;
            .payStatus-wraper{
                height: 100px;
                background: #F9F9FB;
                display: flex;
                align-items: center;
                .status-display{
                    display: flex;
                    align-items: center;
                    .paystatus{
                        font-family: PingFangSC-Semibold;
                        font-size: 24px;
                        color: #333333;
                        font-weight: 700;
                        margin-left: 10px;
                    }
                    img{
                        width: 30px;
                        margin-left: 30px;
                        vertical-align:middle;
                    }
                }
                
            }
        }
        .companyInvo-wraper{
            /deep/ .el-form-item__label{
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #333333;
            }
            /deep/ .el-form-item{
                margin-bottom: 16px;
            }
        }
        .table-status{
            span{
                margin-left: 8px;
            }
        }
        .bgcorange::before{
                content:'';
                width: 10px;
                height: 10px;
                border-radius: 50%;
                display: inline-block;
                background: #FE833D;
            }
        .bgcred::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #fe3d3d;
        }
        .bgcgreen::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #1DCB96;
        }
        .bgcgrey::before{
            content:'';
            width: 10px;
            height: 10px;
            border-radius: 50%;
            display: inline-block;
            background: #C8C8C8;
        }
        .common-leftblue{
            text-align: left;
            padding-left: 10px;
            border-left: 3px solid #0069e0;
            font-family: FZLTZHK--GBK1-0;
            font-size: 14px;
            color: #333333;
            font-weight: 700;
            line-height: 16px;
        }
        .commonFZ14CO33{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333333;
            word-break: break-all;
        }

        /deep/ .el-table .cellstyle{
            padding: 8px 0 !important;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #181818;
            font-weight: 400;
        }
    }

</style>


// WEBPACK FOOTER //
// src/view/CompanyUser/CompanyOrderPay/comOrderDetail.vue